import graphql__a53b4041d2a95ff6749a from "./__generated__/CustomerContactsView_customerAccount.graphql.ts";import * as React from "react";
import {useOutletContext} from "react-router";
import Panel from "./presentational/Panel";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import AddContactDialog from "./dialog/AddContactDialog";
import {faUsers} from '@fortawesome/pro-duotone-svg-icons'
import NoData from "./presentational/NoData";
import DetailedContactList from "./DetailedContactList";
import ActionButton from "./presentational/button/ActionButton";
import {useFragment} from "react-relay/hooks";
import {graphql} from "react-relay";
import {useIntl} from "react-intl";

type Props = {}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type CustomerContactsViewProps = Props & ConnectedProps<typeof connector>;

const CustomerContactsView: React.FC<CustomerContactsViewProps> = (props) => {
    const intl = useIntl();
    const queryRef: any = useOutletContext();
    const customerAccount = useFragment(
        graphql__a53b4041d2a95ff6749a,
        queryRef
    );

    const {dispatchShowModal, dispatchHideModal} = props
    const showAddContactDialog = (customerAccount) => {
        dispatchShowModal({
            body: (<AddContactDialog customerAccount={customerAccount} handleCloseDialog={dispatchHideModal}/>)
        })
    };

    const personContacts = customerAccount.contacts.edges.filter((edge) => {
        return (edge && edge.node && edge.node.__typename === 'PersonContact')
    });
    const teamContacts = customerAccount.contacts.edges.filter((edge) => {
        return (edge && edge.node && edge.node.__typename === 'TeamContact')
    });

    return (
        <Panel headline={intl.formatMessage({id: 'view.customerContacts.headline'})}>
            {customerAccount.contacts.totalCount === 0 &&
                <NoData
                    icon={faUsers}
                    headline={intl.formatMessage({id: 'view.customerContacts.noContacts'})}
                    description={intl.formatMessage({id: 'view.customerContacts.noContactsDescription'})}
                    newButtonLabel={intl.formatMessage({id: 'view.customerContacts.addContact'})}
                    onNewButton={e => showAddContactDialog(customerAccount)}
                />
            }
            {personContacts.length > 0 &&
                <Panel headline={intl.formatMessage({id: 'view.customerContacts.people'})}>
                    <DetailedContactList queryRef={customerAccount} typeNameFilter="PersonContact"/>
                </Panel>
            }
            {teamContacts.length > 0 &&
                <Panel headline={intl.formatMessage({id: 'view.customerContacts.teams'})}>
                    <DetailedContactList queryRef={customerAccount} typeNameFilter="TeamContact"/>
                </Panel>
            }
            {customerAccount.contacts.totalCount > 0 &&
                <div className="text-center py-10">
                    <ActionButton onClick={e => showAddContactDialog(customerAccount)} label={intl.formatMessage({id: 'view.customerContacts.addContact'})}/>
                </div>
            }
        </Panel>
    )
}

export default connector(CustomerContactsView);
